<template>
    <div class="d-flex justify-content-center align-items-center form-data">
        <div>
            <h1 class="mb-3">Forgot your password</h1>
            <div class="dark mb-5">Enter your email address below and we'll get you back on track.</div>

            <form @submit.stop.prevent="resetPassword" :class="['shaded', status]">
                <div class="form-group" :class="{ error: $v.email.$error }">
                    <label class="full">
                        <input v-model.trim="email" type="email" placeholder="Your email here"  @input="$v.email.$touch">
                    </label>

                    <div v-if="$v.email.$error" class="messages">
                        <span v-if="!$v.email.required">Email is required.</span>
                        <span v-if="!$v.email.email">Must be a valid email</span>
                        <span v-if="!$v.email.emailExists">We couldn't find this email on our database</span>
                    </div>
                </div>

                <input type="submit" class="btn action widest full" value="Request reset link">

                <router-link :to="{ name: 'auth.login' }" class="fs-smaller back">
                    Back to sign in
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                email: '',
                status: '',
            }
        },
        validations: {
            email: {
                required,
                email,
                emailExists () {
                    return this.emailExists;
                }
            },
        },
        created: function() {
            this.eventHub.$emit('sidebar', 'login');
            this.eventHub.$emit('topLink', 'signup');
        },
        asyncComputed: {
            async emailExists() {
                let email = this.email;

                if (email != '' && this.$v.email.email) {
                    try {
                        let response = await axios.get(axios.authURL + 'auth/IsEmailFree', { params: { email: email } });

                        if (response && response.status === 200) {
                            return !response.data.isSuccessStatusCode;
                        }
                    }
                    catch (error) {
                        console.log(error.response.data.message);
                    }
                }

                return true;
            },
        },
        methods: {
            resetPassword: function() {
                axios.post(axios.authURL + 'auth/ResetPassword', { email: this.email }).then(response => {
                    if (response && response.status === 200) {
                        this.$router.push({ name: 'auth.login' });

                        this.$toasted.success(response.data.message, { className: 'auth-alert' });
                    }
                    else {
                        this.$toasted.error(response.data.message, { className: 'auth-alert' });
                    }
                })
                .catch(function (error) {
                    this.$toasted.error(error.response.data.message, { className: 'auth-alert' });
                });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?41601064